import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Referential } from 'src/app/models/referential';
import { ServiceResponse } from 'src/app/models/service-response';
import { ClassService } from 'src/app/rest_services/class.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { TeamService } from 'src/app/rest_services/team.service';
import {v4 as uuidv4} from 'uuid';
import { phoneNumberValidator } from 'src/app/validators/phone-number.validator';

@Component({
  selector: 'app-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrls: ['./edit-customer.component.css']
})
export class EditCustomerComponent implements OnInit {

  updateCustomerForm!:FormGroup;
  editSiteForm!:FormGroup;
  editServiceForm!:FormGroup;
  classes: any;
  refSectors:any[]=[];
  refCities:any[]=[];
  commercials:any[]=[];
  updateCustomerRequest:any={};
  classesSubscription!: Subscription;
  commercialsSubscriptions!: Subscription;
  loadingUpdatingCustomer:boolean=false;
  role:any=null;comp:any=null;
  uuid:any;
  customer_cities: any[] = [];
  retrieveCustomerSubscription!:Subscription;
  retrieveCustomerLoder:boolean = false;
  selectedCustomer: any;
  previousValues:any;
  // initialFormData: any;
  formChanged: boolean = false;
  dataRetrieved:boolean = false;
  initialFormValues: { [key: string]: any } = {};
  currentYear: any="0";

  constructor(
    private fb : FormBuilder,
    private customersService:CustomersService,
    private classService: ClassService,
    private settingsService:SettingsService,
    private msSector : MsSectorService,
    private teamService: TeamService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) { 
    this.currentYear = new Date().getFullYear().toString();
    this.updateCustomerForm = this.fb.group({      
      'social': ['', [Validators.required, Validators.maxLength(50)]],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : ['', [Validators.email]],
      'city': [''],
      'zip' : [''],
      'address' : [''],
      'phone' : ['', [phoneNumberValidator()]],
      'skype' : [''],
      'class' : [],
      'commercial': [''],
      'city_label':[''],
      'logo': [''],
      'selectedCity':[''],
      'selectedSite':[''],
      'service': [''],
      'extraSite':[''],
      'ca_year':[this.currentYear],
      'ca_goal':['', [Validators.pattern(/^\d{0,10}([.]\d{1,2})?$/)]],
      'ca_potential':['', [Validators.pattern(/^\d{0,10}([.]\d{1,2})?$/)]]
    });
    this.editSiteForm = this.fb.group({      
      'editedSite': ['', Validators.required],
      'editedAdress' : [''],
    });
    this.editServiceForm = this.fb.group({      
      'editedService': ['', Validators.required],
    });
  }
  htmlYouWantToAdd:any="";
  token : any = '';

  ngOnInit(): void {
    this.getConfig();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.uuid = this.route.snapshot.params['uuid'];
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.comp=localStorage.getItem("comp");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.comp=sessionStorage.getItem("comp");
    }
    sessionStorage.setItem('previousUrl', this.router.url);
    this.retrieveCustomer();
    this.getCities();
    this.getSectors();
    this.getClasses();
    this.getCommercials();
    this.generateYearsWithCurrent();    
    this.currentYear = new Date().getFullYear().toString();
    this.updateCustomerForm.get('ca_year')?.setValue(this.currentYear);
  }
  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  
  getSectors(){
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.refSectors = data.sectors;
        }
      },
    )  
  }

  // isFormUnchanged(): boolean {
  //   const currentFormData = this.updateCustomerForm.value;
  //   return JSON.stringify(currentFormData) === JSON.stringify(this.initialFormData);
  // }

  isFormUnchanged(controlName: string): boolean {
    const currentFormValue = this.updateCustomerForm.get(controlName)?.value;
    const initialFormValue = this.initialFormValues[controlName];
    return currentFormValue === initialFormValue;
  }
  

  compareStringsIgnoringAccents(str1: string, str2: string): boolean {
    const normalizedStr1 = str1.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalizedStr2 = str2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedStr1.toLowerCase() === normalizedStr2.toLowerCase();
  }
  
    addError: string="";
   //add a new city
   newCity() {
    const cityFormValue = this.updateCustomerForm?.get('city_label')?.value;
    if (cityFormValue) {
      const existingCity = this.customer_cities.find((city: any) =>
        this.compareStringsIgnoringAccents(city.name.toString(), cityFormValue.toString())
      );
      const existingRefCity = this.refCities.find((city: any) =>
        this.compareStringsIgnoringAccents(city.city.toString(),cityFormValue.toString())
      );
      if (existingCity !=undefined) {
            this.addError = "La ville que vous avez saisi existe déjà pour ce compte client !";
            $("#city_not_added_input").removeClass("d-none");
            setTimeout(()=>{
              $("#city_not_added_input").addClass("d-none");
            }, 4000);
        //this.cityAdded = this.customer_cities.length > 0;
      }if (existingRefCity != undefined) {
        this.addError = "La ville existe déjà. Veuillez la sélectionner dans la liste déroulante !";
        $("#city_not_added_input").removeClass("d-none");
        setTimeout(()=>{
          $("#city_not_added_input").addClass("d-none");
        }, 4000);
      }else if (!existingCity) {
        const capitalizedCity = cityFormValue.charAt(0).toUpperCase() + cityFormValue.slice(1).toLowerCase();
        const newCity = {
          name: capitalizedCity,
          uuid: uuidv4(),
          sites: []
        };
        this.customer_cities.push(newCity);
        this.formChanged = true;
        //this.cityAdded = this.customer_cities.length > 0;
      }
    }
  } 
  removeCity(city: any) {
    const cityIndex = this.customer_cities.findIndex((c: any) => c.uuid === city.uuid);
    if (cityIndex !== -1) {
      const cityToRemove = this.customer_cities.splice(cityIndex, 1)[0];
      this.formChanged = true;
      // Remove all sites associated with the deleted city
      const siteIndicesToDelete = this.sites
        .filter((site: any) => site.city_uuid === cityToRemove.uuid)
        .map((site: any) => this.sites.indexOf(site))
        .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
      siteIndicesToDelete.forEach((siteIndex) => {
        const deletedSite = this.sites.splice(siteIndex, 1)[0];
  
        // Remove all services associated with the deleted site
        const serviceIndicesToDelete = this.customerService
          .filter((service: any) => service.site_uuid === deletedSite.site_uuid)
          .map((service: any) => this.customerService.indexOf(service))
          .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
        serviceIndicesToDelete.forEach((serviceIndex) => {
          this.customerService.splice(serviceIndex, 1);
        });

        // Remove all services associated with the deleted site
        const serviceToDelete = this.services
        .filter((service: any) => service.site_uuid === deletedSite.site_uuid)
        .map((service: any) => this.services.indexOf(service))
        .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
        serviceToDelete.forEach((serviceIndex) => {
          this.services.splice(serviceIndex, 1);
        });
      });

    }
  }

  sites:any[]=[];
  // New function to add a new site to a city
  newSite() {
   const selectedCityId = this.updateCustomerForm?.get('selectedCity')?.value;
   const siteFormValue = this.updateCustomerForm?.get('extraSite')?.value;
   const addressFormValue = this.updateCustomerForm?.get('address')?.value;
   if (selectedCityId && siteFormValue) {
     const selectedCity = this.customer_cities.find((city: any) => city.uuid === selectedCityId);
     if (selectedCity) {
       const existingSite = this.sites.find((site: any) => site.siteName === siteFormValue && site.cityUuid === selectedCityId);
       if (!existingSite) {
         const newSite = {
           siteName: siteFormValue,
           siteUuid: uuidv4(),
           cityUuid: selectedCityId,
           siteAddress: addressFormValue, // Add address to newSite
           customerService: []
         };
         this.sites.push(newSite);
         selectedCity.sites.push(newSite);
         this.updateCustomerForm?.get('extraSite')?.setValue('');
         this.updateCustomerForm?.get('address')?.setValue('');
         $("#selectedCities").val("");
         // this.siteAdded = this.sites.length > 0;
        //  const btn = document.getElementById('saveChanges') as HTMLButtonElement | null;
        //  if (btn) {
        //    btn.disabled = false;
        //  }
         this.formChanged = true;         
         
       }
       else{
        this.addError = "Le site que vous avez saisi existe déjà pour ce compte client !";
        $("#site_not_added").removeClass("d-none");
        setTimeout(()=>{
          $("#site_not_added").addClass("d-none");
        }, 4000);
       }
     }
   }
 }

 removeSite(site: any, city: any) {
  const siteIndex = this.sites.findIndex((s: any) => s.site_uuid === site.site_uuid);
  if (siteIndex !== -1) {
    this.sites.splice(siteIndex, 1);
    const cityIndex = city.sites.findIndex((s: any) => s.site_uuid === site.site_uuid);
    this.formChanged = true;
    if (cityIndex !== -1) {
      city.sites.splice(cityIndex, 1);
      // Remove the related customerService for the deleted site
      const relatedServices = site.customerService;
      for (const service of relatedServices) {
        const serviceIndex = site.customerService.findIndex((s: any) => s.service_uuid === service.service_uuid);
        if (serviceIndex !== -1) {
          site.customerService.splice(serviceIndex, 1);
        }
        const servicesIndex = this.customerService.findIndex((s: any) => s.service_uuid === service.service_uuid);
        if (servicesIndex !== -1) {
          this.customerService.splice(servicesIndex, 1);
        }
      }
    }
  }
}

editSite() {
  const editedSiteName = this.editSiteForm.value.editedSite;
  const editedAddress = this.editSiteForm.value.editedAdress;

  // Find the index of the selected site in the item.sites array
  const index = this.sites.findIndex(site => site.siteUuid === this.selectedSite.siteUuid);

  // Update the site name and address
  this.sites[index].siteName = editedSiteName;
  this.sites[index].siteAddress = editedAddress;
  // Close the modal
  $('#editSite').hide();

  // Remove the modal backdrop
  $('.modal-backdrop').remove();

  // Re-enable the scroll bar
  $('body').removeClass('modal-open');
  this.formChanged = true;
  // Clear the form
  this.editSiteForm.reset();
}
selectedService:any;
selectService(ele:any){
  $('#editService').show()
  this.selectedService = ele;
  this.editServiceForm.controls['editedService'].setValue(this.selectedService.service_name);
}
editService() {
  const editedServiceName = this.editServiceForm.value.editedService;

  // Find the index of the selected site in the item.sites array
  const index = this.customerService.findIndex(service => service.service_uuid === this.selectedService.service_uuid);
  // Update the site name and address
  this.customerService[index].service_name = editedServiceName;

  // Update the service name in sites
  this.sites.forEach(site => {
    const serviceIndex = site.customerService.findIndex((service:any) => service.service_uuid === this.selectedService.service_uuid);
    if (serviceIndex !== -1) {
      site.customerService[serviceIndex].service_name = editedServiceName;
    }
  });
  // Close the modal
  $('#editService').hide();
  $('.modal-backdrop').remove();
  $('body').removeClass('modal-open');
  
  this.formChanged = true;

  this.editServiceForm.reset();
}
customerService: any[] = [];
services: any[] = [];

addService() {
  const selectedSiteId = this.updateCustomerForm?.get('selectedSite')?.value;
  const serviceName = this.updateCustomerForm?.get('service')?.value;
  if (selectedSiteId && serviceName) {
    const selectedSite = this.sites.find((site: any) => site.siteUuid === selectedSiteId);
    if (selectedSite) {
      const existingService = selectedSite.customerService.find((service: any) => service.service_name === serviceName);
      if (!existingService) {
        const newService = {
          service_name: serviceName,
          service_uuid: uuidv4(),
          site_uuid: selectedSiteId
        };
        selectedSite.customerService.push(newService);
        this.customerService.push(newService);
        this.formChanged = true;
        this.updateCustomerForm?.get('service')?.setValue('');
        // You can update the selected site value as needed.
         $("#selectedSites").val("");
      }else{
        this.addError = "Le service que vous avez saisi existe déjà pour ce compte client !";
        $("#service_not_added").removeClass("d-none");
        setTimeout(()=>{
          $("#service_not_added").addClass("d-none");
        }, 4000);
       }
    }
  }
}

getCityName(cityUuid: string): string {
  const city = this.customer_cities.find((c: any) => c.uuid === cityUuid);
  return city ? city.name : 'Unknown City'; // Replace 'Unknown City' with your desired default value.
}


removeService(service: any, site: any) {
  // Find the index of the service within the site's customerService array
  const serviceIndex = site.customerService.findIndex((s: any) => s.service_name === service.service_name);
  if (serviceIndex !== -1) {
    // Remove the service from the site's customerService array
    site.customerService.splice(serviceIndex, 1);
    this.formChanged = true;

    // Find the index of the service within the global customerService array
    const globalServiceIndex = this.customerService.findIndex((s: any) => s.service_name === service.service_name);
    if (globalServiceIndex !== -1) {
      // Remove the service from the global customerService array
      this.customerService.splice(globalServiceIndex, 1);
    }
  }
}

selectedSite:any;
selectElement(ele:any){
  $('#editSite').show()
  this.selectedSite =ele;
  this.editSiteForm.controls['editedSite'].setValue(this.selectedSite.siteName);
  this.editSiteForm.controls['editedAdress'].setValue(this.selectedSite.siteAddress);
}
  selectedLogo: File | null = null; // Add this property

  onLogoSelect(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedLogo = inputElement.files[0];
      this.formChanged =true;
    }
  }
  updateCustomer() {
    var valuesUpdateCustomerForm = this.updateCustomerForm.value;
    let customerClass = new Referential();
    customerClass.uuid = valuesUpdateCustomerForm.class;

    this.loadingUpdatingCustomer = true;

    if (this.updateCustomerForm.valid) {
      this.updateInProgress = true;
      
      this.updateCustomerRequest = {
        social_reason:valuesUpdateCustomerForm.social,
        customer_sector:valuesUpdateCustomerForm.sector,
        represented_by:valuesUpdateCustomerForm.agent,
        customer_email:valuesUpdateCustomerForm.email,
       // customer_city:valuesUpdateCustomerForm.city,
        customer_zip:valuesUpdateCustomerForm.zip,
        customer_address:valuesUpdateCustomerForm.address,
        customer_phone: valuesUpdateCustomerForm.phone,
        customer_skype: valuesUpdateCustomerForm.skype,
        customer_refClass: valuesUpdateCustomerForm.class ? customerClass : null,
        customerCommercial: valuesUpdateCustomerForm.commercial,
        customer_cities:this.customer_cities,
        customer_sites: this.sites,
        customer_services: this.customerService,
        customer_ca_year:valuesUpdateCustomerForm.ca_year,
        customer_ca_goal:valuesUpdateCustomerForm.ca_goal,
        customer_ca_potential:valuesUpdateCustomerForm.ca_potential
      };
      if (this.selectedLogo) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const logoDataUrl = e.target?.result as string;
          this.updateCustomerRequest.customer_logo = logoDataUrl.split(',')[1];
          this.callUpdateCustomerAPI();
        };
        reader.readAsDataURL(this.selectedLogo);
      } else {
        this.callUpdateCustomerAPI();
      }
    }
  }
  updateSubscription!: Subscription;
  private callUpdateCustomerAPI() {
    this.customersService.updateCustomerRequest = this.updateCustomerRequest;
    this.customersService.updateCustomer(this.uuid);

    this.updateSubscription = this.customersService.updateCustomerSubject.subscribe(
      ( data: any ) => {
      this.updateInProgress = false;
        if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
          $("html, body").animate({scrollTop:0})
          this.loadingUpdatingCustomer = false;
          $("#customer_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            // Navigate to the customer page with the newly created customer's uuid
            const newCustomerUuid = data.customer.customer;
            const customerPageUrl = '/customer/fromshow;cs=' + newCustomerUuid;
            this.router.navigateByUrl(customerPageUrl);
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_updated").hide();
          }, 3000);
          setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "iDisplayLength": 25,
              "scrollCollapse": true,
              order: [[4, 'desc']],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);

        }else {
          this.loadingUpdatingCustomer = false;
          $("#customer_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_updated").hide();
          }, 4000);
        }
      },
    );
  }

  updateInProgress: boolean = false;
  cancelModification() {
    this.location.back();
  }
  selectYear: any = new Date().getFullYear();
  selectYearCa(year: any) {
    if (this.selectedCustomer?.annualCAc?.length > 0) {
      // Convertir l'année en nombre pour la comparaison
      const targetYear = Number(year);
      
      // Filtrer les entrées valides
      const validYears = this.selectedCustomer.annualCAc.filter(
        (i: any) => i.year !== "null" && i.year !== null && !isNaN(Number(i.year))
      );
      
      // Chercher l'entrée correspondante
      const selectedCA = validYears.find((i: any) => Number(i.year) === targetYear);
      
      if (selectedCA) {
        this.updateCustomerForm.patchValue({
          'ca_year': selectedCA.year,
          'ca_goal': selectedCA.goal,
          'ca_potential': selectedCA.potential,
        });
      } else {
        // Aucune donnée pour cette année
        this.updateCustomerForm.patchValue({
          'ca_year': year,
          'ca_goal': null,
          'ca_potential': null,
        });
      }
    } else {
      // Pas de données du tout
      this.updateCustomerForm.patchValue({
        'ca_year': year,
        'ca_goal': null,
        'ca_potential': null,
      });
    }
  }

  retrieveCustomer(){
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(this.uuid,this.currentYear.toString()).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          this.selectedCustomer = data.customer;         
          this.msSector.getSector(this.token,this.selectedCustomer.sector).subscribe(
            (sectorLabel: any) => {
              this.selectedCustomer.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          // Loop through customer_cities and collect sites
          if (this.selectedCustomer.customer_cities != null) {
            this.selectedCustomer.customer_cities.forEach((city: any) => {
              if (city.sites && city.sites.length > 0) {
                // Concatenate the sites to this.sites
                this.sites = this.sites.concat(city.sites);
              }
            });
          }
          // Collect services
          if (this.sites != null) {
            this.sites.forEach((site: any) => {
              if (site.customerService && site.customerService.length > 0) {
                site.customerService.forEach((service: any) => {
                  const formattedService = {
                    service_name: service.service_name,
                    service_uuid: service.service_uuid,
                    site_uuid: service.site_uuid
                  };
                  this.customerService.push(formattedService);
                });
              }
            });
          }                    
          this.updateCustomerForm.patchValue({
            'social' : this.selectedCustomer.customer_rs,
            'sector' : this.selectedCustomer.sector,
            'agent' : this.selectedCustomer.customer_agent,
            'email' : this.selectedCustomer.customer_email,
            // 'city' : this.selectedCustomer.customer_city,
            'zip' : this.selectedCustomer.customer_zip_code,
            // 'address' : this.selectedCustomer.customer_address,
            'phone' : this.selectedCustomer.customer_phone,
            'skype' : this.selectedCustomer.customer_skype,
            'class': this.selectedCustomer.customerClass ? this.selectedCustomer.customerClass.uuid : null,
            'commercial': (this.selectedCustomer.commercials[this.selectedCustomer.commercials.length-1]?.commercial_uuid)?this.selectedCustomer.commercials[this.selectedCustomer.commercials.length-1]?.commercial_uuid:''
          });
          if (this.selectedCustomer.annualCAc?.length > 0) {
            // First try to find a valid entry for the current year
            const cleanData = this.selectedCustomer.annualCAc
              .filter((item: any) => item.year !== "null" && item.year !== null && !isNaN(Number(item.year)))
              .map((item: any) => ({ ...item, year: Number(item.year) }));

            let currentCA = cleanData.find((item: any) => item.year === Number(this.currentYear));

            // If no valid year entry found, check for "null" year entries as fallback
            if (!currentCA && cleanData.length > 0) {
              currentCA = cleanData[0];
            }

            // Fallback: if cleanData is empty, use entries with year "null" 
            if (!currentCA) {
              const nullYearEntry = this.selectedCustomer.annualCAc.find(
                (item: any) => item.year === "null" || item.year === null
              );
              if (nullYearEntry) {
                currentCA = {
                  year: Number(this.currentYear), // assign current year
                  goal: nullYearEntry.goal,
                  potential: nullYearEntry.potential,
                };
              }
            }

            if (currentCA) {
              this.updateCustomerForm.patchValue({
                'ca_year': currentCA.year,
                'ca_goal': currentCA.goal,
                'ca_potential': currentCA.potential,
              });
              this.selectYear = currentCA.year;
            } else {
              this.updateCustomerForm.patchValue({
                'ca_year': this.currentYear,
                'ca_goal': null,
                'ca_potential': null,
              });
              this.selectYear = Number(this.currentYear);
            }
          }
           // Check if the customer has a logo
          if (this.selectedCustomer.customer_logo) {
            // Convert the base64 logo to a data URL
            const logoDataUrl = 'data:image/*;base64,' + this.selectedCustomer.customer_logo;
            const imageDiv = document.getElementById('imageDiv');
            if (imageDiv) {
              // Create an <img> element and set its src attribute
              const imgElement = document.createElement('img');
              imgElement.src = logoDataUrl;
              imgElement.alt = 'Customer Logo';
              imgElement.style.width = '100px';
              // imgElement.style.marginLeft = 'auto';
              // imgElement.style.display = 'block';
              imgElement.style.border = '2px solid #000'; // Add a border
              // Clear any existing content in the imageDiv and append the image
              imageDiv.innerHTML = '';
              imageDiv.appendChild(imgElement);
            }
          }
          this.initialFormValues['social'] = this.updateCustomerForm.get('social')?.value;
          this.initialFormValues['sector'] = this.updateCustomerForm.get('sector')?.value;
          this.initialFormValues['agent'] = this.updateCustomerForm.get('agent')?.value;
          this.initialFormValues['email'] = this.updateCustomerForm.get('email')?.value;
          this.initialFormValues['zip'] = this.updateCustomerForm.get('zip')?.value;
          this.initialFormValues['address'] = this.updateCustomerForm.get('address')?.value;
          this.initialFormValues['phone'] = this.updateCustomerForm.get('phone')?.value;
          this.initialFormValues['skype'] = this.updateCustomerForm.get('skype')?.value;
          this.initialFormValues['class'] = this.updateCustomerForm.get('class')?.value;
          this.initialFormValues['commercial'] = this.updateCustomerForm.get('commercial')?.value;
          this.initialFormValues['logo'] = this.updateCustomerForm.get('logo')?.value;
          this.initialFormValues['ca_year'] = this.updateCustomerForm.get('ca_year')?.value;
          this.initialFormValues['ca_goal'] = this.updateCustomerForm.get('ca_goal')?.value;
          this.initialFormValues['ca_potential'] = this.updateCustomerForm.get('ca_potential')?.value;

          // this.updateCustomerForm.valueChanges.subscribe(() => {
          //   this.formChanged = !this.isFormUnchanged();
          // });
          this.updateCustomerForm.get('social')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('social');
          });

          this.updateCustomerForm.get('sector')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('sector');
          });

          this.updateCustomerForm.get('agent')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('agent');
          });

          this.updateCustomerForm.get('email')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('email');
          });

          this.updateCustomerForm.get('zip')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('zip');
          });

          this.updateCustomerForm.get('address')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('address');
          });

          this.updateCustomerForm.get('phone')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('phone');
          });

          this.updateCustomerForm.get('skype')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('skype');
          });

          this.updateCustomerForm.get('class')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('class');
          });

          this.updateCustomerForm.get('commercial')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('commercial');
          });

          this.updateCustomerForm.get('logo')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('logo');
          });

          this.updateCustomerForm.get('ca_year')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('ca_year');
          });

          this.updateCustomerForm.get('ca_goal')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('ca_goal');
          });

          this.updateCustomerForm.get('ca_potential')?.valueChanges.subscribe(() => {
            this.formChanged = !this.isFormUnchanged('ca_potential');
          });

          if(this.selectedCustomer.customer_cities!=null){
            this.customer_cities=this.selectedCustomer.customer_cities;
          }
          // Add customer_city to the customer_cities array
          if (this.selectedCustomer.customer_city) {
            const customerCity = {
              uuid: this.selectedCustomer.customer_city,
              name: $( "#citiesSelect option:selected" ).text(),
            };
            this.customer_cities.push(customerCity);
          }
        }
        this.retrieveCustomerLoder = false;
        this.dataRetrieved= true;
        var glob = this;
        var blocActions = this.htmlYouWantToAdd;
        $(document).ready(function() {
          $('#citiesSelect').change(function() {
            var value = $(this).val();
            var elt = glob.customer_cities.find((el:any) => el.uuid == value);
            var uuid = $("option:selected", this).attr("ud");
            var city = {
              name: $( "#citiesSelect option:selected" ).text(),
              sites: [],
              uuid: uuid
            };
            let index = -1;
            if (elt !== undefined) {
              index = glob.customer_cities.findIndex((d :any) => d.name == elt.city);
            }
            if (index < 0 && value !== "") {
              var alreadySelected = glob.customer_cities.some((item: any) => item.uuid === uuid);
              if (!alreadySelected) {
                const existingCity = glob.customer_cities.find((item: any) =>
                  glob.compareStringsIgnoringAccents(item.name.toString(), city.name.toString())
                );
                if (!existingCity) {
                  glob.customer_cities.push(city);
                  glob.formChanged=true;
                  setTimeout(function() {
                    $('#citiesSelect').val("");
                  }, 500);
                }
              } else {
                glob.addError = "La ville que vous avez sélectionné existe déjà pour ce compte client !";
                $("#city_not_added_select").removeClass("d-none");
                $('#citiesSelect').val("");
                setTimeout(()=>{
                  $("#city_not_added_select").addClass("d-none");
                }, 4000);
              }
            }         
            // Update the 'city' form control's required attribute based on the customer_cities array
            const cityFormControl = $('#citiesSelect')[0] as HTMLSelectElement;
            cityFormControl.required = glob.customer_cities.length === 0;
    
            // Update the validity of the 'city' form control
            cityFormControl.setCustomValidity(cityFormControl.validity.valid ? '' : 'Please select a city.');
          });
          // Get references to the file input and imageDiv elements
          const logoInput = document.getElementById('logoInput') as HTMLInputElement;
          const imageDiv = document.getElementById('imageDiv');
    
          // Add an event listener to the file input
          logoInput?.addEventListener('change', (event) => {
              const selectedFile = logoInput.files?.[0]; // Use the logoInput reference
    
              // Check if a file was selected
              if (selectedFile) {
                  // Read the selected file as a data URL
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    const logoDataUrl = e.target?.result as string; // Use optional chaining
                    // Create an <img> element and set its src attribute
                    const imgElement = document.createElement('img');
                    imgElement.src = logoDataUrl;
                    imgElement.alt = 'Selected Logo';
                    imgElement.style.width = '100px';
                    // imgElement.style.marginLeft = 'auto';
                    // imgElement.style.display = 'block';
                    imgElement.style.border = '2px solid #000'; // Add a border
                    if(imageDiv){
                      // Clear any existing content in the imageDiv and append the image
                    imageDiv.innerHTML = '';
                    imageDiv.appendChild(imgElement);
                    }
                  };
                  reader.readAsDataURL(selectedFile);
              } else {
                  // Clear the imageDiv if no file is selected
                  if (imageDiv)imageDiv.innerHTML = '';
              }
          });
          
        });
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false; 
      }
    );
  }


  getCities(){
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;
        }
      },
    )  
  }
 
  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
          setTimeout(() => this.updateCustomerForm.get('class')?.setValue(this.updateCustomerForm.get('class')?.value ?? null, { emitEvent: false }));
        }    
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getCommercials() {
    this.commercialsSubscriptions = this.teamService.getCommercials().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "b1f37eec383fcada527079602ac178b3"){
          this.commercials = resp.commercials;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

   years: any[] = [];
  
  generateYearsWithCurrent(): void {
    const currentYear = new Date().getFullYear();
    
    // 4 années suivantes (désactivées)
    for (let i = 0; i <= 4; i++) {
      const year = currentYear + i;      
      if(year==this.currentYear){
        this.years.push({
          value: year,
          text: year.toString(),
          disabled: false,
          selected: true
        });
      }else if (year==Number(this.currentYear)+1){
        this.years.push({
          value: year,
          text: year.toString(),
          disabled: false,
          selected: false
        });
      }else {
        this.years.push({
          value: year,
          text: year.toString(),
          disabled: true
        });
      }
    }
  }
}

